import EmberRouter from '@ember/routing/router';
import config from 'linced-app/config/environment';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;
}

Router.map(function () {
  this.route('attendance', function () {
    this.route('absences', { path: '/absences/:date_id/:period_id' });
    this.route('admin', { path: '/:date_id' });
  });
  this.route('comet', { path: '/comet/:goal_id' });
  this.route('login');
  this.route('home', function () {
    this.route('daily-notices', function () {
      this.route('notice', { path: '/:post_id' });
    });
    this.route('community-notices', function () {
      this.route('notice', { path: '/:post_id' }, function () {
        this.route('analysis');
      });
    });
    this.route('student-notices', function () {
      this.route('notice', { path: '/:post_id' });
    });
    this.route('text-messages', function () {
      this.route('message', { path: '/:post_id' });
    });
    this.route('hero-notices', function () {
      this.route('notice', { path: '/:post_id' });
    });
    this.route('events', function () {
      this.route('event', { path: '/:event_id' });
    });
    this.route('control-panel');
  });
  this.route('school-options', function () {
    this.route('basic-details');
    this.route('group', { path: '/groups/:optiongroup_id' });
    this.route('dates');
  });
  this.route('hero-support', function () {
    this.route('group', { path: '/groups/:optiongroup_id' });
  });
  this.route('about');
  this.route('my-profile');
  this.route('my-feed');
  this.route('callback');
  this.route('login-failed');
  this.route('logout');
  this.route('logged-out');
  this.route('school-switching');
  this.route('springboard');

  this.route('people', function () {
    this.route('person', { path: '/:person_id' }, function () {
      this.route('posts');
      this.route('post', { path: '/posts/:post_id' }, function () {
        this.route('analysis');
      });
      this.route('information');
      this.route('finance', function () {
        this.route('line-item', { path: '/line-items/:lineitem_id' });
        this.route('transactions');
        this.route('account', { path: '/:account_id' });
        this.route('donations');
      });
      this.route('page', { path: '/pages/:page_id' }, function () {
        this.route('assessment', { path: '/assessments/:assessment_id' });
        this.route('unlinked-posts');
        this.route('goals');
      });
      this.route('attendance');
      this.route('assessments', function () {
        this.route('assessment', { path: '/:assessment_id' });
      });
      this.route('goals', function () {
        this.route('subject', { path: '/subjects/:subject_id' });
      });
      this.route('goal', { path: '/goals/:goal_id' });
      this.route('progressions', function () {
        this.route('edit', { path: '/edit/:subject_id' });
        this.route('changelog', {
          path: '/changelog/:subject_id/:progression_id',
        });
      });
      this.route('groups');
      this.route('manage');
      this.route('notifications');
      this.route('manage-settings');
      this.route('report-snapshots');
    });
  });
  this.route('groups');
  this.route('group', { path: '/groups/:group_id' }, function () {
    this.route('attendance');
    this.route('assessments', function () {
      this.route('assessment', { path: '/:assessment_id' });
    });
    this.route('assessment-overview');
    this.route('goals', function () {
      this.route('subject', { path: '/subjects/:subject_id' });
      this.route('matrix', { path: '/matrix/:subject_id' });
      this.route('table', { path: '/table/:subject_id' });
    });
    this.route('expectations', function () {
      this.route('subject', { path: '/subjects/:subject_id' });
    });
    this.route('data-wall');
    this.route('triangulation', function () {
      this.route('subject', { path: '/subjects/:subject_id' });
      this.route('combined');
    });
    this.route('quick-comments', function () {
      this.route('page', { path: '/:page_id' });
    });
    this.route('posts', function () {});
    this.route('insights', function () {
      this.route('attendance');
      this.route('assessments', function () {
        this.route('current', function () {
          this.route('assessment', { path: '/:assessment_id' });
        });
        this.route('progress', function () {
          this.route('assessment', { path: '/:assessment_id' });
        });
      });
      this.route('content');
      this.route('engagement');
      this.route('progress', function () {
        this.route('dots', { path: '/dots/:subject_id' });
        this.route('overview', { path: '/overview/:subject_id' });
        this.route('breakdown', { path: '/breakdown/:subject_id' });
        this.route('rates', function () {
          this.route('subject', { path: '/subjects/:subject_id' });
        });
        this.route('progress', function () {
          this.route('subject', { path: '/subjects/:subject_id' });
        });
        this.route('latest');
      });
    });
    this.route('page', { path: '/pages/:page_id' }, function () {
      this.route('assessment', { path: '/assessments/:assessment_id' });
    });
    this.route('bulk-publish');
    this.route('bulk-print');
    this.route('medical-schedule');
    this.route('sidekick');
    this.route('topics', function () {
      this.route('subject', { path: '/subject/:subject_id' });
      this.route('topic', { path: '/topic/:goal_id' }, function () {
        this.route('overview', { path: '/overview/:goal_id' });
        this.route('table', { path: '/table/:goal_id' });
        this.route('posts', { path: '/posts/:goal_id' });
        this.route('data-wall', { path: '/data-wall/:goal_id' });
        this.route('details');
      });
    });
  });

  this.route('goals', function () {
    this.route('subject', { path: '/subjects/:subject_id' });
    this.route('plp');
  });
  this.route('goal', { path: '/goals/:goal_id' });

  this.route('topics', function () {
    this.route('subject', { path: '/subjects/:subject_id' });
  });
  this.route('topic', { path: '/topics/:goal_id' });
  this.route('topics-overview');

  this.route('freestyle');

  this.route('milestones');

  this.route('admin', function () {
    this.route('staff');
    this.route('staffmember', { path: '/staff/:person_id' });
    this.route('list-builder');
    this.route('list');
    this.route('tags', function () {
      this.route('category', { path: '/categories/:category_id' });
    });
    this.route('pages');
    this.route('assessments');
    this.route('assessment', { path: '/assessments/:assessment_id' });
    this.route('grade-schedules');
    this.route('batches');
    this.route('finance', function () {
      this.route('ledgers');
      this.route('ledger-items', function () {
        this.route('item', { path: '/:item_id' });
        this.route('bulk-writeoff', { path: 'bulk-writeoff/:year' });
      });
      this.route('debtors-report');
      this.route('reporting');
      this.route('statements');
      this.route('xero-batches');
      this.route('cost-centres');
      this.route('internal-orders');
      this.route('banking', function () {
        this.route('tills');
        this.route('till-sessions');
        this.route('deposit-slips');
        this.route('daily-summaries');
      });
      this.route('community', function () {
        this.route('line-item', { path: '/line-items/:lineitem_id' });
      });
    });
    this.route(
      'quick-payment',
      { path: '/finance/quick-payment' },
      function () {
        this.route('receipt', { path: '/receipt/:transaction_id' });
      },
    );
    this.route('stripe-connect', { path: '/finance/stripe-connect' });
    this.route('xero-connect', { path: '/finance/xero-callback' });
    this.route('reports', function () {
      this.route('batch', function () {});

      this.route('finance', function () {
        this.route('batch', function () {
          this.route('ledger', { path: '/ledger/:ledger_id' });
          this.route('ledger-item', { path: '/ledger-item/:item_id' });
        });
        this.route('transactions');
        this.route('ledger-item-summary');
        this.route('reconciliation');
        this.route('ledger-analysis');
        this.route('line-item-detail');
        this.route('item-ledger-summary');
      });

      this.route('attendance', function () {
        this.route('absentees', { path: '/absentees/:date_id/:period_id' });
        this.route('unexplained', { path: '/unexplained/:date_id/:period_id' });
        this.route('class-attendance-audit');
        this.route('absences-and-truancy-report');
        this.route('evacuation', { path: '/evacuation/:date_id/:period_id' });
      });
    });
    this.route('groups');
    this.route('autogroups');

    this.route('people', function () {
      this.route('schema', function () {
        this.route('group', { path: '/groups/:group_id' });
      });
    });

    this.route('lists', function () {
      this.route('class-lists', function () {
        this.route('all');
        this.route('emergency');
        this.route('tabular');
        this.route('class-counts');
        this.route('enrolment-year-level');
        this.route('funding-year-level');
        this.route('new-previous-class');
        this.route('current-new-class');
        this.route('basic-class-counts');
        this.route('class-roll');
        this.route('team-roll');
        this.route('year-level-counts');
      });

      this.route('student-lists', function () {
        this.route('eldest-youngest');
        this.route('eldest-youngest-class');
        this.route('family-directory');
        this.route('full-school-directory');
        this.route('caregiver-user-accounts');
        this.route('caregiver-finance-access');
        this.route('medical-room');
      });

      this.route('other-lists', function () {
        this.route('athenaeum-transfer');
        this.route('dental-service');
        this.route('full-dental-service');
        this.route('signmee-transfer');
        this.route('house-year-level-counts');
        this.route('field-level-audit');
      });

      this.route('board-elections', function () {
        this.route('edit-voting-rights');
        this.route('board-main-roll');
      });

      this.route('non-current-students', function () {
        this.route('pre-enrolments');
        this.route('leavers-list');
      });

      this.route('attendance', function () {
        this.route('attendance-tracker');
        this.route('attendance-term-audit-list');
        this.route('analysis');
        this.route('daily-absences');
        this.route('change-of-attendance-record');
        this.route('moe-audit-term-attendance-register');
        this.route('resourcing-analysis');
        this.route('absences-and-truancy-report');
        this.route('absent-rate-analysis-report');
      });

      this.route('exports', function () {
        this.route('attendance-survey');
        this.route('generate-upload');
        this.route('ide');
      });
    });
    this.route('import', function () {
      this.route('groups');
      this.route('link-siblings');
      this.route('profileimages');
      this.route('assessment-data');
      this.route('finance');
      this.route('finance-pia');
      this.route('replacement-media');
      this.route('attendance');
      this.route('sif-au');
      this.route('wonde');
      this.route('sif-logs');
      this.route('te-rito');
    });
    this.route('class-placements');
    this.route('import-logs', function () {
      this.route('import', { path: '/:bulk_import_id' });
    });

    this.route('bookings', function () {
      this.route('create');
      this.route('edit', { path: '/edit/:event_id' });
    });
    this.route('interventions');
    this.route('post-templates');
    this.route('medications', function () {
      this.route('log');
      this.route('schedule', function () {
        this.route('all');
      });

      this.route('reports', function () {
        this.route('student');
        this.route('stocktake');
        this.route('anaphylaxis');
      });
    });
    this.route('events', function () {
      this.route('permissions');
      this.route('options');
      this.route('templates');
      this.route('risks');
    });
  });

  this.route('enrolment', function () {
    this.route('form');
    this.route('applications');
    this.route('pending');
    this.route('unenrol');
    this.route('view-application', { path: '/:application_id' });
  });
  this.route('search');
  this.route('data-sheets', function () {
    this.route('page', { path: '/pages/:page_id' });
  });

  this.route('reporting-updates');
  this.route('reporting', function () {
    this.route('group', { path: '/group/:group_id' }, function () {
      this.route('write', { path: '/write/:template_id' });
      this.route('review', { path: '/review/:template_id' });
      this.route('view', { path: '/view/:template_id' });
      this.route('student', { path: '/student/:person_id' }, function () {
        this.route('write', { path: '/write/:student_report_id' });
        this.route('review', { path: '/review/:student_report_id' });
        this.route('view', { path: '/view/:student_report_id' });
      });
    });
  });
  this.route('guides');
  this.route('resources');
  this.route('engage');

  this.route('import');

  this.route('nz-moe', function () {
    this.route('roll-returns', function () {
      this.route('roll-return', { path: '/:roll_return_id' });
      this.route('approval', { path: '/:roll_return_id/approval' });
    });
    this.route('bulk-upload', function () {
      this.route('arrivals');
      this.route('leavers');
    });
  });

  this.route('surveys', function () {
    this.route('results', { path: '/:survey_id' });
  });
  this.route('my-subscriptions');
  this.route('sickbay', function () {
    this.route('admin');
    this.route('register');
  });

  this.route('moderation', function () {
    this.route('comments');
  });
  this.route('feature-packs', function () {
    this.route('pages');
    this.route('milestones');
    this.route('goals');
    this.route('parent-view');
    this.route('communication');
  });

  this.route('wellbeing', function () {
    this.route('incidents');
    this.route('suspensions');
    this.route('expulsions');
  });

  this.route('locations');

  this.route('school', function () {
    this.route('page', { path: '/:page_id' });
  });

  this.route('report-snapshots');

  this.route('customise', function () {
    this.route('templates');
    this.route('report-builder');
    this.route('report-builder-edit', { path: '/report-builder/:template_id' });
  });

  // Default Route - Do not put routes beneath this one
  this.route('not-found', { path: '/*path' });
});
